import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Zoom from '@material-ui/core/Zoom';

import CircularProgress from '@material-ui/core/CircularProgress';

function Transition(props) {
  return <Zoom {...props} />;
}

const styles = theme => ({
  title: {
    fontFamily: 'Lumberjack Inline Rough',
    fontSize: 20
  },
  text: {

  },
  progress: {
      display: 'block',
      textAlign: 'center'
  }
});

class Loading extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleClose = () => {
    if(this.props.onClose) {
        this.props.onClose();
    }
  };

  render() {
    const { classes, onClose, description, ...other } = this.props;

    return (
      <Dialog TransitionComponent={ Transition } onClose={ this.handleClose } disableBackdropClick={ true } aria-labelledby="Laden..." {...other}>
        <DialogTitle>
          <Typography className={ classes.title }>
            Even geduld
          </Typography>
        </DialogTitle>
        <List>
          <ListItem>
            <ListItemText>
              <Typography className={ classes.text } variant="subheading" id="simple-modal-description">
                  { description }
              </Typography>
            </ListItemText>
          </ListItem>
          <ListItem className={ classes.progress }>
            <CircularProgress className={ classes.spinner } />
          </ListItem>
        </List>
      </Dialog>
    );
  }
}

export default withStyles(styles)(Loading);